export default {
    quiz: null
};
